import React, { useContext } from 'react'
import { JobContext } from '../../context/JobContext'
import { SnackAlert } from '../SnackAlert'

export function JobSnack(): React.JSX.Element {
  const { jobSnack } = useContext(JobContext)
  return <SnackAlert {...jobSnack} />
}
